/**
 * Flat key/value rows ↔ pipelineVariables object (same idea as Denali pipeline editor filter variables).
 */

export { DEFAULT_SUPPLEMENTAL_ITEMS_PATH } from '../../../../../organisms/StatusReport/supplementalLayouts/constants'

function valueToRowString (value) {
  if (value === undefined || value === null) return ''
  if (typeof value === 'string') return value
  return JSON.stringify(value)
}

export function pipelineVariablesToRows (obj) {
  if (obj == null || typeof obj !== 'object' || Array.isArray(obj)) return []
  return Object.entries(obj).map(([key, value]) => ({
    key,
    value: valueToRowString(value)
  }))
}

function coercePipelineVariableInput (raw) {
  const t = typeof raw === 'string' ? raw.trim() : raw
  if (t === '') return undefined
  if (typeof t === 'string' && t.startsWith('$')) return t
  try {
    return JSON.parse(t)
  } catch {
    return t
  }
}

/** Skips rows with empty keys. Returns null if no entries. */
export function pipelineVariableRowsToObject (rows) {
  const out = {}
  for (const row of rows || []) {
    const k = typeof row?.key === 'string' ? row.key.trim() : ''
    if (!k) continue
    const coerced = coercePipelineVariableInput(row?.value ?? '')
    if (coerced !== undefined) out[k] = coerced
  }
  return Object.keys(out).length ? out : null
}
